import {  BOOK_LIST_GQL } from './gql';
import { apolloClient } from '../client';
import { Book } from '../types.generated';

export const bookListQuery = async (): Promise<Book[] | undefined> => {
  const response = await apolloClient.query<{books: Book[]}>({
    query: BOOK_LIST_GQL,
    variables: {},
  });

  return response.data?.books;
};
